module.exports = __webpack_public_path__ + "static/media/23-6.6e018235.mp3";